<app-spinner [(show)]="loading"></app-spinner>
<main class="esf-main-content -has-transition -width-max" *ngIf="!loading">
  <div class="esf-container main-content--fit-screen">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <span class="esf-action-heading__text">{{ selectedClub.name }}</span>
      <span class="esf-action-heading__actions">
          <span class="esf-action-heading__action">
            <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                    [edsTooltip]="i18nDeleteClub"
                    [disabled]="selectedClub.status !== 'inactive'"
                    (click)="showDeleteModal()">
              <svg class="esf-icon" width="16" height="16">
                <use xlink:href="#esf-icon-trash"></use>
              </svg>
            </button>
          </span>
      </span>
    </h1>

    <div class="esf-info-tile-grid esf-info-tile-grid--3">
      <app-club-data-info
        class="esf-info-tile-grid__item"
        style="display: flex; flex-direction: column;"
        [selectedClub]="selectedClub">
      </app-club-data-info>
      <app-club-communication-info
        style="display: flex; flex-direction: column;"
        class="esf-info-tile-grid__item"
        [selectedClub]="selectedClub">
      </app-club-communication-info>
      <app-club-personalization
        style="display: flex; flex-direction: column;"
        class="esf-info-tile-grid__item"
        [authenticatedUser]="authenticatedUser"
        [selectedClub]="selectedClub">
      </app-club-personalization>
      <app-club-gdpr-settings-info
        class="esf-info-tile-grid__item"
        style="display: flex; flex-direction: column;"
        [selectedClub]="selectedClub">
      </app-club-gdpr-settings-info>
    </div>

    <div class="esf-accordion esf-accordion--info-tiles">

      <app-club-address [selectedClub]="selectedClub" [countries]="countries"></app-club-address>

      <div style="display: flex; justify-content: space-between;">

        <app-club-product-access [selectedClub]="selectedClub" style="flex: 1; margin-right: 10px;"></app-club-product-access>

        <app-modules-list [selectedClub]="selectedClub" style="flex: 1; margin-left: 10px;"></app-modules-list>

      </div>
      <app-website-settings *ngIf="selectedClub.website && selectedClub.isLotteryActive" [selectedClub]="selectedClub"></app-website-settings>

      <app-webhook-settings [selectedClub]="selectedClub"></app-webhook-settings>

    </div>

  </div>
</main>

<app-edit-club-data [selectedClub]="selectedClub"
                    *ngIf="clubOverviewService.listOfModals.editClubDataModal">
</app-edit-club-data>

<app-edit-club-communication [selectedClub]="selectedClub"
                             *ngIf="clubOverviewService.listOfModals.editClubCommunicationModal">
</app-edit-club-communication>

<app-edit-club-address [selectedClub]="selectedClub"
                       [countries]="countries"
                       *ngIf="clubOverviewService.listOfModals.editClubAddressModal">
</app-edit-club-address>

<app-edit-club-bank-data [selectedClub]="selectedClub"
                         *ngIf="clubOverviewService.listOfModals.editClubBankDataModal">
</app-edit-club-bank-data>

<app-edit-club-gdpr-settings [selectedClub]="selectedClub"
                             *ngIf="clubOverviewService.listOfModals.editClubGdprSettingsModal">
</app-edit-club-gdpr-settings>

<app-tixx-connect [selectedClub]="selectedClub"
                  *ngIf="clubOverviewService.listOfModals.editTixxConnect"></app-tixx-connect>

<app-campaign [selectedClub]="selectedClub"
              *ngIf="clubOverviewService.listOfModals.editCampaign"></app-campaign>

<app-fan-score-card [selectedClub]="selectedClub"
                    *ngIf="clubOverviewService.listOfModals.editFanScoreCard"></app-fan-score-card>

<app-campai-membership [selectedClub]="selectedClub"
                       *ngIf="clubOverviewService.listOfModals.editCampaiMembership"></app-campai-membership>

<app-tixx-webshop [selectedClub]="selectedClub"
                  *ngIf="clubOverviewService.listOfModals.editTixxWebshop"></app-tixx-webshop>

<app-tixx-select [selectedClub]="selectedClub"
                 *ngIf="clubOverviewService.listOfModals.editTixxSelect"></app-tixx-select>

<app-modules-form [selectedClub]="selectedClub"
                  *ngIf="clubOverviewService.listOfModals.editModulesModal">
</app-modules-form>

<app-webhook-form [selectedClub]="selectedClub"
                  *ngIf="selectedClub.webhooks && clubOverviewService.listOfModals.editWebhookModal">
</app-webhook-form>

<app-webhook-create-form [selectedClub]="selectedClub"
                         *ngIf="selectedClub.webhooks && clubOverviewService.listOfModals.createWebhookModal">
</app-webhook-create-form>

<app-edit-website-settings [selectedClub]="selectedClub"
                           *ngIf="clubOverviewService.listOfModals.editWebsiteModal">
</app-edit-website-settings>

<app-upload-club-logo [selectedClub]="selectedClub" (logoUploaded)="logoUploaded($event)"
                      *ngIf="clubOverviewService.listOfModals.editLogoModal">
</app-upload-club-logo>
